
export const CLASSICAL_STRATEGY = 'classical';
export const QUANTUM_STRATEGY = 'quantum';

export const BELL_STATES = {
  'Φ+': 'phi_plus',
  'Φ-': 'phi_minus',
  'Ψ+': 'psi_plus',
  'Ψ-': 'psi_minus',
};
